import { render, staticRenderFns } from "./HoldingsBreakdownChart.vue?vue&type=template&id=1828977a&scoped=true"
import script from "./HoldingsBreakdownChart.vue?vue&type=script&lang=js"
export * from "./HoldingsBreakdownChart.vue?vue&type=script&lang=js"
import style0 from "./HoldingsBreakdownChart.vue?vue&type=style&index=0&id=1828977a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828977a",
  null
  
)

export default component.exports